import { Card, CardContent } from "@/components/ui/card";
import { ScanLine, Upload } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function ReceiptScanningPage() {
  const navigate = useNavigate();
  return (
    <div data-testid="receipt-scanning-page">
      <div className="mb-6"><h1 className="font-heading font-bold text-2xl text-[#1F2937]">Receipt Scanning</h1>
        <p className="text-sm text-gray-500 mt-1">Scan and process receipts using OCR</p></div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card className="border rounded-sm cursor-pointer hover:shadow-md transition-shadow" onClick={() => navigate("/payment-capture")}>
          <CardContent className="p-6"><div className="w-12 h-12 rounded-lg flex items-center justify-center mb-3 text-blue-600 bg-blue-50"><ScanLine className="w-6 h-6" /></div>
            <h3 className="font-semibold text-[#1F2937] mb-1">Payment Proof Scanning</h3><p className="text-sm text-gray-500">Upload proof of payment documents for OCR processing</p>
            <Button size="sm" className="mt-3 bg-[#E63946] hover:bg-[#C1121F] text-white rounded-sm"><Upload className="w-4 h-4 mr-1" />Upload POP</Button></CardContent></Card>
        <Card className="border rounded-sm cursor-pointer hover:shadow-md transition-shadow" onClick={() => navigate("/expenses")}>
          <CardContent className="p-6"><div className="w-12 h-12 rounded-lg flex items-center justify-center mb-3 text-green-600 bg-green-50"><ScanLine className="w-6 h-6" /></div>
            <h3 className="font-semibold text-[#1F2937] mb-1">Expense Receipt Scanning</h3><p className="text-sm text-gray-500">Scan expense receipts to auto-create expense records</p>
            <Button size="sm" className="mt-3 bg-[#E63946] hover:bg-[#C1121F] text-white rounded-sm">Go to Expenses</Button></CardContent></Card>
      </div>
    </div>
  );
}
